import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';
import {Attribute} from '../../../components/ObjectAttribute';

const loginRequest: RequestExample = {
    title: {
        verb: 'POST',
        endpointUrl: '/api/login',
    },
    curl:
        `curl --location \\
--request POST '<YOUR SERVER>/api/login' \\
--header 'Content-Type: application/json' \\
--data-raw '{
    "appName": "App Name",
    "appDescription": "my description",
    "appId": 12345,
    "username": "JohnSmith",
    "password": "password12345",
    "mfaCode": "123456",
    "deviceId": "<unique-device-id>"
}'`
    ,
};

const loginResponse: Json = {
    title: 'RESPONSE',
    json: {
        'token': '7dd6bcf7-5e92-4c25-86c9-54af4a831d54',
        'user': {
            'id': 5,
            'userFullName': 'John Smith',
            'moduleAccessList': [
                'Company',
                'Customer',
                'Payment Receipt',
                'Dashboard',
                'Product',
                'Home',
                'Property',
                'Custom Field',
                'Receiving',
                'Payment Gateway',
                'Calendar',
                'RMA',
                'Reports',
                'Data',
                'Sales Order Invoice',
                'Vendor',
                'Location Group',
                'UOM',
                'Part Label',
                'Schedule',
                'Memo',
                'Location',
            ],
            'serverVersion': '20.11.20201111'
        }
    },
};

const loginAttributes: Attribute[] = [
    {
        name: 'appName',
        type: 'string',
        description: 'The name of your application.'
    },
    {
        name: 'appDescription',
        type: 'string',
        description: 'A brief description of what your application does.'
    },
    {
        name: 'appId',
        type: 'integer',
        description: 'The unique identifier for your integrated application. Use any number you want, but we recommend at least 4 digits in length.'
    },
    {
        name: 'username',
        type: 'string',
        description: 'The username of the user logging in.'
    },
    {
        name: 'password',
        type: 'string',
        description: 'The user\'s password.'
    },
    {
        name: 'mfaCode',
        type: 'string',
        description: 'The TOTP code from the user\'s authenticator app. Required if the user has enabled MFA (multi-factor authentication).',
        optional: true
    },
    {
        name: 'deviceId',
        type: 'string',
        description: 'Identifies a particular device. Used to determine if a user is using a trusted device and whether an MFA code is required. ' +
            'Should be a unique value per device to avoid collisions between devices.',
        optional: true,
    }
]

const data: RequestDefinitionData = {
    id: 'login',
    title: 'Logging in to Fishbowl',
    description: 'This logs the user in to Fishbowl and returns the list of Access Rights. ' +
        'The first time your Integrated App logs in, you\'ll need to approve the App in Fishbowl. ' +
        'If the user has enabled MFA (multi-factor authentication), the response will return HTTP 401 with a response header "MFA: Required". ' +
        'Resend the same request object with the mfaCode field included to log in.',
    endpoint: {
        verb: 'POST',
        path: '/login',
        tooltip: 'Login',
    },
    attributes: loginAttributes,
    requestObject: loginRequest,
    responseObject: loginResponse,
    wiki: {
        link: 'https://www.fishbowlinventory.com/wiki/Settings#Integrated_Apps_tab',
        linkName: 'Approving Integrations',
    },
}

export default data;
